import './header.css'
import Logo from '../../asset/logo.png'
import { Link } from 'react-router-dom'

export function Header(params: any): JSX.Element {
  const color = params.Colore.Rgba
  const stileDiv = {
    backgroundColor: `rgba(${color.r}, ${color.g}, ${color.b}, 0.904)`,
  }
  return (
    <div id="header" style={stileDiv}>
      <div className="container">
        <a href={"https://www.regione.emilia-romagna.it/"}>{params.Regione.Nome}</a>
        <Link to="/setup">
          <h3 style={stileDiv} className="accediAlArea">
            Accedi all'area privata
          </h3>
        </Link>
      </div>
      <HeaderBottom name={params.Name} colore={stileDiv} />
    </div>
  )
}
function HeaderBottom(props: any) {
  return (
    <div className="headerBottom" style={props.colore}>
      <h3 id="nameTitel">
        <span>
          <img src={Logo} alt="" />
        </span>
        {props.name}
      </h3>
    </div>
  )
}
